module.exports = window.React;